import { mutations } from "@/graphql";
import { useState } from "react";
import { useMutation } from "@apollo/client/react";
export const useAddModule = (
  onCompleted: (data?: any) => void = () => {},
  onError: (error?: any) => void = () => {},
) => {
  const [success, setSuccess] = useState(false);
  const [resetForm, setResetForm] = useState(false);

  const [addModule, { loading, data }] = useMutation<any>(mutations.addModule, {
    onCompleted: (response) => {
      if (response.addModule?.success || response.comAddModule?.success) {
        setSuccess(true);
        setResetForm(true);
        setTimeout(() => {
          setSuccess(false);
          setResetForm(false);
        }, 5000);
        onCompleted();
      } else {
        setSuccess(false);
      }
    },
    onError: ({ message }) => {
      setSuccess(false);
      onError(message);
    },
  });
  return {
    addModule,
    loading,
    success,
    data,
    resetForm,
  };
};
